import React, { ReactNode } from 'react'

import './index.less'
import { emptyFolderIcn } from '../../../assets/CustomIcons'
import Icon from '@ant-design/icons'

interface CommonPlaceholderProps {
  title: string
  content: string | ReactNode
  danger?: boolean
  borderless?: boolean
}

export const CommonPlaceholder = ({ title, content, danger, borderless }: CommonPlaceholderProps): JSX.Element => {
  return (
    <div className={`CommonPlaceholder ${danger ? 'danger' : ''} ${borderless ? 'borderless' : ''}`}>
      <div className="CommonPlaceholder__container">
        <Icon component={emptyFolderIcn} />

        <h6>{title}</h6>
        {typeof content === 'string' ? <p>{content}</p> : <>{content}</>}
      </div>
    </div>
  )
}
